import { useTranslation } from 'react-i18next';
import { Arrow, Directions } from 'components/Shared/Arrow';

export default function CarouselButtons({
  next,
  previous,
  slideIndex,
  setSlideIndex,
  onSlideChange,
  images,
}: {
  next: () => void;
  previous: () => void;
  slideIndex: number;
  setSlideIndex: React.Dispatch<React.SetStateAction<number>>;
  onSlideChange: (index: number) => void;
  images: string[];
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <Arrow
          direction={Directions.Left}
          onClick={(): void => {
            if (slideIndex === 0) {
              setSlideIndex(images.length - 1);
              onSlideChange(images.length - 1);
            } else {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              setSlideIndex((val: number) => val - 1);
              onSlideChange(slideIndex - 1);
            }
            previous();
          }}
          style={{ position: 'absolute', left: '0', top: '40%', marginLeft: '16px' }}
          alt={t('previous')}
          data-testid="previous-slide-arrow"
        />
        <Arrow
          alt={t('next')}
          data-testid="next-slide-arrow"
          onClick={(): void => {
            if (slideIndex === images.length - 1) {
              setSlideIndex(0);
              onSlideChange(0);
            } else {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              setSlideIndex((val: number) => val + 1);
              onSlideChange(slideIndex + 1);
            }
            next();
          }}
          style={{ position: 'absolute', right: '0', top: '40%', marginRight: '16px' }}
          direction={Directions.Right}
        />
      </div>
      <style>
        {`
          .react-multiple-carousel__arrow {
            display: none;
          }
        `}
      </style>
    </>
  );
}
